import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import Iframe from 'react-iframe'
import CountUp from 'react-countup';
import Youtube from '../headerone/Youtube'
import {LanguageContext} from '../../LanguageContext';

function About(props) {

    const [video, setVideo] = useState();
    const {language, setLanguage} = useContext(LanguageContext);

    return (
    <>
        <section className="about-area about-p pt-80 p-relative fix" >
            
            <div className="container">
                <div className="row">
                    <div className="col-12">

                        <div className="row justify-content-center align-items-center bgColor" >
                            <div className="col-lg-6 col-md-12 col-sm-12 px-5 py-5 c-video">
                                <Youtube />
                            </div>
                            
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                
                                <div className="about-content s-about-content pl-15 pb-30 pt-30 pr-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">
                                    <h3>
                                    <i className="fal fa-graduation-cap" />{language==='en'?'About IIT Tirupati':'आईआईटी तिरुपति के बारे में'} 
                                    </h3>
                                    {/* <h4 className='titleh3'>{language==='en'?'A Few Words About IIT Tirupati':'आईआईटी तिरुपति के बारे में कुछ शब्द'}</h4> */}
                                </div>
                                <p className="txt-clr caboutus">
                                    {language==='en'?'IIT Tirupati has a high potential to be an Academic and Research Institute of great repute.':'आईआईटी तिरुपति में एक प्रतिष्ठित शैक्षणिक और शोध  संस्थान बनने की प्रखर क्षमता है।'}
                                </p>
                                <p  className="caboutus">
                                {language==='en'?'The Indian Institute of Technology Tirupati (IIT Tirupati), established in 2015, is an autonomous Institute under Ministry of Education, Government of India. It is declared as an Institute of National Importance under the Act of Parliament of India (Institutes of Technology Act, 1961).'
                                :
                                'वर्ष 2015 में स्थापित भारतीय प्रौद्योगिकी संस्थान तिरुपति  (आईआईटी तिरुपति) भारत सरकार के शिक्षा मंत्रालय के अधीन एक स्वायत्त संस्थान है। इसे भारत के संसद के अधिनियम (प्रौद्योगिकी संस्थान अधिनियम, 1961) के तहत राष्ट्रीय महत्व का संस्थान घोषित किया गया है।'}
                                <br />
                                </p>
                                {props.showVisionMission=="yes" &&
                                <>
                                <div className="about-content2">
                                    <div className="row">
                                    <div className="col-md-12">
                                        <ul className="green2">
                                        <li>
                                            <div className="abcontent">
                                            {/* <div className="ano">
                                                <span>01</span>
                                            </div> */}
                                            {" "}
                                            <div className="text">
                                                <h3>{language==='en'?'Vision':'विज़न'}</h3>{" "}
                                                <p>
                                                {language==='en'?'•	To contribute to society through excellence in scientific and technical education and research...':'• उत्कृष्ट वैज्ञानिक एवं तकनीकी शिक्षा और शोध के माध्यम से समाज में योगदान देना...'}
                                                </p>
                                            </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="abcontent">
                                                {/* <div className="ano">
                                                    <span>02</span>
                                                </div> */}
                                            {" "}
                                            <div className="text">
                                            <h3>{language==='en'?'Mission':'मिशन'}</h3>{" "}
                                                <p>
                                                {language==='en'?'• To generate new knowledge by engaging in cutting-edge research and to promote academic growth...':'• अत्याधुनिक शोध में प्रवृत्त होते हुए नवीन ज्ञान विकसित करना तथा अत्याधुनिक स्नातक...'}
                                                </p>
                                            </div>
                                            </div>
                                        </li>
                                        </ul>
                                    </div>
                                    </div>
                                </div>
                                <div className="slider-btn mt-20">
                                    <Link to="/aboutus" className="btn ss-btn smoth-scroll">
                                    {language==='en'?'Read More':'और पढ़ें'} <i className="fal fa-long-arrow-right" />
                                    </Link>
                                </div>
                                </>
                                }
                                </div>
                            </div>
                        </div>



                        
                    </div>
                </div>
                
            </div>





            <div className="counter-area pb-90" style={{ background: "#da4a47" }}>
                <div className="container">
                    <div className="row p-relative">
                    
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="single-counter wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="counter p-relative" style={{ backgroundImage: "url(assets/img/bg/c-object.png)", backgroundRepeat: "no-repeat" }} >
                            <CountUp className="count" start={0} end={136} ></CountUp>
                            <p>+<br/>{language==='en'?'Faculty':'संकाय'}</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="single-counter wow fadeInUp animated" data-wow-offset="100" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="counter p-relative" style={{ backgroundImage: "url(assets/img/bg/c-object.png)", backgroundRepeat: "no-repeat" }} >
                            <CountUp className="count" start={0} end={131} >  </CountUp>
                            <p>+<br/>{language==='en'?'Staff':'कर्मचारी'}</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="single-counter wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="counter p-relative" style={{ backgroundImage: "url(assets/img/bg/c-object.png)", backgroundRepeat: "no-repeat" }} >
                            <CountUp className="count" start={0} end={1826} ></CountUp>
                            <p>+<br/>{language==='en'?'Students':'छात्र'}
                            </p>
                        </div>
                        </div>
                    </div>


                                {/* Ram disable below code before 8 month */}
                    {/* <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="single-counter wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="counter p-relative" style={{ backgroundImage: "url(assets/img/bg/c-object.png)", backgroundRepeat: "no-repeat" }} >
                            <CountUp className="count" start={0} end={220} ></CountUp>
                            <p>+<br/>Publications
                            </p>
                        </div>
                        </div>
                    </div> */}


                    
                    </div>
                </div>

                
            </div>




        </section>

        

       

    </>
  )
}

export default About;